const DEV_API_URL = process.env.NEXT_PUBLIC_DEV_API_URL || '';
const PRODUCTION_API_URL = process.env.NEXT_PUBLIC_PRODUCTION_API_URL || '';

const DEV_API_BASE_URLS = [
  { domain: 'localhost:3000', api_url: DEV_API_URL },
  { domain: 'localhost', api_url: DEV_API_URL },
  { domain: 'tenant.localhost:3000', api_url: DEV_API_URL },
  { domain: 'tenant.localhost', api_url: DEV_API_URL },
  // Same-origin proxy (see next.config.js rewrites) — avoids CORS in local tenant testing.
  {
    domain: 'codementors.local',
    api_url: 'https://api.witrovipdemo.ir/api',
  },
];

export const API_BASE_URL_EXCEPTIONS = [
  { domain: 'witro.shop', api_url: PRODUCTION_API_URL },
  { domain: 'witrodev.ir', api_url: DEV_API_URL },
  ...DEV_API_BASE_URLS,
];
